import React from 'react'
import { FormattedMessage } from 'react-intl'

export const DIALOG_ALLOCATING_RESOURCES_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.title"
        defaultMessage="Распределение ресурсов"
    />
)

export const DIALOG_ALLOCATING_RESOURCES_SUBMIT_BUTTON_CAPTION = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.submit_button.caption"
        defaultMessage="Распределить"
    />
)

export const DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBER_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.divide_to_member.title"
        defaultMessage="Начислить ресурсы игроку:"
    />
)

export const DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBERS_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.divide_to_members.title"
        defaultMessage="Распределить ресурсы между игроками:"
    />
)

export const DIALOG_ALLOCATING_RESOURCES_SELECT_CURRENCY = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.select_currency.title"
        defaultMessage="Распределяемый ресурс:"
    />
)

export const DIALOG_ALLOCATING_RESOURCES_BEFORE_DIVIDE_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.before_divide.title"
        defaultMessage="До распределения:"
    />
)

export const DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_ONE_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.divide_to_one.title"
        defaultMessage="Начислить:"
    />
)

export const DIALOG_ALLOCATING_RESOURCES_DIVIDE_EACH_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.divide_each.title"
        defaultMessage="Начислить каждому:"
    />
)

export const DIALOG_ALLOCATING_RESOURCES_AMOUNT_OF_CHARGES_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.amount_of_charges.title"
        defaultMessage="Сумма начислений:"
    />
)

export const DIALOG_ALLOCATING_RESOURCES_AFTER_DIVIDE_TITLE = (
    <FormattedMessage
        id="members_control_block.dialog.allocating_resources.after_divide.title"
        defaultMessage="После распределения:"
    />
)



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/AllocatingResources/translations.js